import { render, staticRenderFns } from "./coinpayments-button.vue?vue&type=template&id=1b35cb2f&scoped=true&"
import script from "./coinpayments-button.vue?vue&type=script&lang=js&"
export * from "./coinpayments-button.vue?vue&type=script&lang=js&"
import style0 from "./coinpayments-button.vue?vue&type=style&index=0&id=1b35cb2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b35cb2f",
  null
  
)

component.options.__file = "coinpayments-button.vue"
export default component.exports